import { Flow, Reservation } from "types/entities";
import { IntlShape, useIntl } from "react-intl";
import { findActiveComponent } from "./filter";
import { dateToString, formatTime } from "./dateFormat";

const mappedTitle = {
	Profile: "home.profileTitle",
	ChangePassword: "home.changePasswordTitle",
	RecoverPassword: "home.recoverPasswordTitle",
	Register: "home.registerTitle",
	LoginFromProfile: "home.loginTitle",
	Home: "home.systemTitle",
	FindTable: "home.findTableTitle",
	ChooseService: "home.serviceTitle",
	Login: "home.loginTitle",
	Details: "home.detailsTitle",
};

export const generateHeaderTitle = (
	activeStep: number,
	selectedFlow: Flow,
	reservation: Reservation,
	formatMessage: any,
	locale: string,
	isCalledFromProfile: boolean
): { title: string; showBusinessName: boolean } => {
	const component = findActiveComponent(selectedFlow, activeStep);

	const titleId = mappedTitle[component as keyof typeof mappedTitle];
	if (!titleId) {
		return {
			title: formatMessage({ id: "home.systemTitle" }),
			showBusinessName: true,
		};
	}

	let title = "";
	let showBusinessName = false;

	if (
		activeStep >= 0 &&
		titleId !== "home.loginTitle" &&
		titleId !== "home.detailsTitle"
	)
		showBusinessName = true;

	switch (titleId) {
		case "home.loginTitle":
			if (!isCalledFromProfile) {
				title = generateLoginTitle(reservation, locale, formatMessage);
				showBusinessName = false;
			}
			break;
		case "home.findTableTitle":
			if (reservation.service) {
				title = reservation.service.name;
				showBusinessName = false;
			}
			break;
		case "home.serviceTitle":
			if (reservation.service?.category.name === "Event") {
				title = `${formatMessage({
					id: "home.eventTitle",
					defaultMessage: "Evento",
				})} ${reservation.service.name}`;
				showBusinessName = false;
			}
			break;
		case "home.profileTitle":
			title = `${formatMessage({
				id: titleId,
				defaultMessage: "Título desconocido",
			})} ${reservation.customer.name}`;
			break;
		default:
			title = formatMessage({
				id: titleId,
				defaultMessage: "Título desconocido",
			});
			break;
	}

	if (title === "")
		title = formatMessage({
			id: titleId,
			defaultMessage: "Título desconocido",
		});

	return { title, showBusinessName };
};

const generateLoginTitle = (
	reservation: Reservation,
	locale: string,
	formatMessage: any
) => {
	let translatedText = "";
	if (reservation.numberDiners === 1)
		translatedText = formatMessage({
			id: "home.loginTitlePeopleSingular",
			defaultMessage: "persona para",
		});
	else
		translatedText = formatMessage({
			id: "home.loginTitlePeople",
			defaultMessage: "personas para",
		});

	const time = reservation.time!.toLocaleTimeString("es-ES", {
		hour: "2-digit",
		minute: "2-digit",
	});

	return `${reservation.numberDiners} ${translatedText} ${dateToString(
		reservation.time!,
		locale
	)} - ${formatTime(time, locale)}`;
};
